import type { PlaybackMode } from '../database/custom-types/playback-mode'
import type { TPlaylist } from '../models/playlist'
import { coercePlaybackMode } from '../database/custom-types/playback-mode'

/**
 * Effective playback mode for a **campaign-shaped** registration assignment: prefer an explicit
 * value on a published playlist document when any playlist in the campaign defines it; otherwise
 * the campaign row.
 *
 * @see docs/plans/playlist-architecture.md (campaign removal — `playbackMode` moves to playlists)
 */
export function effectiveChannelPlaybackModeForPlayerRegistration(
  campaignPlaybackMode: PlaybackMode | null | undefined,
  publishedPlaylistDocuments: ReadonlyArray<Pick<TPlaylist, 'playbackMode'>>
): PlaybackMode {
  const raw = publishedPlaylistDocuments.find(p => p.playbackMode !== undefined)?.playbackMode
  const fromPlaylist = raw !== undefined ? coercePlaybackMode(raw) : undefined
  return fromPlaylist ?? coercePlaybackMode(campaignPlaybackMode)
}
